module.exports = __webpack_public_path__ + "img/ipad-en-2BU.31e3002.jpg";